import { render } from "./BindAmazon.vue?vue&type=template&id=ad3021d0&scoped=true"
import script from "./BindAmazon.vue?vue&type=script&lang=js"
export * from "./BindAmazon.vue?vue&type=script&lang=js"

import "./BindAmazon.vue?vue&type=style&index=0&id=ad3021d0&scoped=true&lang=less"
import "./BindAmazon.vue?vue&type=style&index=1&id=ad3021d0&lang=css"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad3021d0"]])

export default __exports__